import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import StudyDetail from "./pages/StudyDetail";
import Marketing from "./pages/Marketing";
import ExtractionScience from "./pages/ExtractionScience";
import CompoundLibrary from "./pages/CompoundLibrary";
import Dashboard from "./pages/Dashboard";
import KnowledgeGraph from "./pages/KnowledgeGraph";
import KnowledgeGraph3D from "./pages/KnowledgeGraph3D";

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/dashboard"} component={Dashboard} />
      <Route path={"/knowledge-graph"} component={KnowledgeGraph} />
      <Route path={"/knowledge-graph-3d"} component={KnowledgeGraph3D} />
      <Route path={"/study/:id"} component={StudyDetail} />
      <Route path={"/marketing"} component={Marketing} />
      <Route path={"/extraction"} component={ExtractionScience} />
      <Route path={"/compounds"} component={CompoundLibrary} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
